import type { App } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { queryStringRouteGuard } from './queryStringRouteGuard'
import { routes } from './routes'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach(queryStringRouteGuard)

export default function (app: App) {
  app.use(router)
}

export { router }
